import { ensure, ensureArray, TType } from "types/service";

import { configPageableMetaType, IPageable } from "@/core/api";
import { dateType, TDate } from "@/core/dates";
import { consultantProfileType, IConsultantProfile } from "@/data/consultant-profiles";
import { configWorkOrderType, IWorkOrder } from "@/data/work-orders";
import { IWithRouteMatchProps, IWithRoutePropsProps } from "@/infrastructure/Route";

export interface IAssignment extends IWorkOrder {
  assignmentConsultantProfile: IConsultantProfile;
  initialStartDate: TDate;
}

export const configAssignmentType: TType<IAssignment> = {
  ...configWorkOrderType,
  assignmentConsultantProfile: consultantProfileType,
  initialStartDate: dateType(),
};

export const assignmentType = ensure(configAssignmentType);

export interface IPageableAssignment extends IPageable<IAssignment[]> {}

export const pageableAssignmentTypeConfig: TType<IPageableAssignment> = {
  ...configPageableMetaType,
  content: ensureArray(assignmentType),
};

export const pageableAssignmentType = ensure(pageableAssignmentTypeConfig);

export interface IAssignmentIdMatchParam {
  assignmentId: string;
}

export interface IAssignmentDetailIdRouteProps {
  assignmentId: number;
}

export interface IAssignmentDetailMatchProps extends IWithRouteMatchProps<IAssignmentIdMatchParam> {}
export interface IAssignmentDetailRouteProps extends IWithRoutePropsProps<IAssignmentDetailIdRouteProps> {}

export interface IAssignmentRevision extends IAssignment {}

export const configAssignmentRevisionType: TType<IAssignmentRevision> = {
  ...configAssignmentType,
};

export const assignmentRevisionType = ensure(configAssignmentRevisionType);
export const assignmentsRevisionType = ensureArray(assignmentRevisionType);
